import {NgModule} from "@angular/core";
import {ChatsComponent} from "./chats/chats.component";
import {HeaderComponent} from "./header/header/header.component";
import {FooterComponent} from "./footer/footer.component";
import {StudentActionsComponent} from "./student-actions/student-actions.component";
import {IonicModule} from "@ionic/angular";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {TranslocoDirective, TranslocoPipe} from "@jsverse/transloco";
import {StudentRequestComponent} from "./modals/student-request/student-request.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IntlTelInputNgModule} from "intl-tel-input-ng";
import {BannersComponent} from "./banners/banners.component";
import {NoCourseNoticeComponent} from "./no-course-notice/no-course-notice.component";
import {EnglishLevelsComponent} from "./modals/english-levels/english-levels.component";
import {LanguageSwitcherComponent} from "./language-switcher/language-switcher.component";
import {AppInboxComponent} from "./app-inbox/app-inbox.component";
import {ChooseTestComponent} from "./modals/choose-test/choose-test.component";
import {CharityDonateFormComponent} from "./modals/charity-donate-form/charity-donate-form.component";
import {CharityDonateSuccessComponent} from "./modals/charity-donate-success/charity-donate-success.component";
import {CharityDonateStorageModalComponent} from "./modals/charity-donate-storage-modal/charity-donate-storage-modal.component";
import {DonationOfferComponent} from "./modals/donation-offer/donation-offer.component";
import {CharityDonateLimitExceededComponent} from "./modals/charity-donate-limit-exceeded/charity-donate-limit-exceeded.component";


@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        RouterModule,
        TranslocoDirective,
        TranslocoPipe,
        FormsModule,
        IntlTelInputNgModule,
        ReactiveFormsModule
    ],

    exports: [
        ChatsComponent,
        HeaderComponent,
        FooterComponent,
        StudentActionsComponent,
        TranslocoDirective,
        TranslocoPipe,
        StudentRequestComponent,
        BannersComponent,
        NoCourseNoticeComponent,
        LanguageSwitcherComponent,
        AppInboxComponent,
        ChooseTestComponent,
        CharityDonateFormComponent,
        CharityDonateSuccessComponent,
        CharityDonateStorageModalComponent,
        DonationOfferComponent,
        CharityDonateLimitExceededComponent,
    ],
    declarations: [
        ChatsComponent,
        HeaderComponent,
        FooterComponent,
        StudentActionsComponent,
        StudentRequestComponent,
        BannersComponent,
        NoCourseNoticeComponent,
        EnglishLevelsComponent,
        LanguageSwitcherComponent,
        AppInboxComponent,
        ChooseTestComponent,
        CharityDonateFormComponent,
        CharityDonateSuccessComponent,
        CharityDonateStorageModalComponent,
        DonationOfferComponent,
        CharityDonateLimitExceededComponent,
    ]
})
export class ComponentsModule {
}
